import Header from "../header/Header";
import Footer from "../footer/Footer";
import Training from "../Training/Training";
import React from "react";

const Trainingpage = () => {
  return (
    <div>
      <Header />
      <Training />
      <Footer />
    </div>
  );
};

export default Trainingpage;
